import React, {Component} from "react";
import Group, {GroupDescription, GroupHead} from "../../../Components/Group";
import Button from "../../../Components/Control/Button";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import ModalProduct from "../../Modal/ModalProduct";
import {ModalAction} from "../../../Components/Modal";
import Resource from "../../../Resource";
import ModalProductState from "../../Modal/ModalProductState";
import Prompt, {PromptControl} from "../../../Components/Prompt";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import {connect} from "react-redux";
import ModalProductScan from "../../Modal/ModalProductScan";
import BarcodeReader from "react-barcode-reader";
import Product from '../../../Server/Product';
import Perms from '../../../Perms';
import Org from "../../../Server/Org";

class PageOrgIncoming extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        if (!Perms().ORG_INCOMING.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    headerName: 'اطلاعات فرآورده',
                    children: [{
                        field: 'productNumber',
                        headerName: 'شماره فرآورده',
                        headerTooltip: 'شماره فرآورده',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        filter: 'agTextColumnFilter'
                    }, {
                        field: 'productTypeStr',
                        headerName: 'نوع فرآورده',
                        headerTooltip: 'نوع فرآورده'
                    }, {
                        field: 'productBloodGroupStr',
                        headerName: 'BGRh فرآورده',
                        headerTooltip: 'BGRh فرآورده',
                        cellClass: row => 'green'
                    }, {
                        field: 'productCollectionDate',
                        headerName: 'تاریخ جمع‌آوری',
                        headerTooltip: 'تاریخ جمع‌آوری',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime.bind(this, 'date')
                    }, {
                        field: 'productExpireDate',
                        headerName: 'تاریخ انقضا',
                        headerTooltip: 'تاریخ انقضا',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime.bind(this, 'date')
                    }]
                }, {
                    headerName: 'اطلاعات ثبت فرآورده',
                    children: [{
                        field: 'userFullName',
                        headerName: 'انجام دهنده',
                        headerTooltip: 'انجام دهنده',
                    }, {
                        field: 'productCreateDateTime',
                        headerName: 'زمان ثبت',
                        headerTooltip: 'زمان ثبت',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    }]
                }, {
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state',
                    valueGetter: row => {
                        const expire = {
                            1: 'نزدیک به انقضا',
                            2: 'منقضی شده'
                        }[row.data.isProductExpiredTny] || null;

                        if (expire)
                            return [row.data.productStatusStr, expire];
                        else
                            return row.data.productStatusStr;
                    }
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 190,
                    hide: !(Perms().BLOOD_BANK_INCOMING.UPDATE ||
                        Perms().BLOOD_BANK_INCOMING.DELETE ||
                        Perms().BLOOD_BANK_INCOMING.DESTROY ||
                        Perms().BLOOD_BANK_INCOMING.RETRIEVE_TO_ORG),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            <GridState theme={'green'}>{row.data.productStatusStr}</GridState>
                            {/* eslint-disable-next-line eqeqeq */}
                            {row.data.isProductExpiredTny == 1 && <GridState theme={'yellow'}>نزدیک به انقضا</GridState>}
                            {/* eslint-disable-next-line eqeqeq */}
                            {row.data.isProductExpiredTny == 2 && <GridState theme={'red'}>منقضی شده</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {Perms().BLOOD_BANK_INCOMING.UPDATE && <GridButton type={"button"} theme={'edit'} title={'ویرایش فرآورده'} onClick={this.update.bind(this, row.data)}/>}
                            {Perms().BLOOD_BANK_INCOMING.DELETE && <GridButton type={"button"} theme={'delete'} title={'حذف فرآورده'} onClick={this.del.bind(this, row.data)}/>}
                            {Perms().BLOOD_BANK_INCOMING.DESTROY && <GridButton type={"button"} theme={'red'} title={'امحا فرآورده'} icon={Resource.IMAGE.PACK.TARGET.WHITE} onClick={this.destroy.bind(this, row.data)}/>}
                            {Perms().BLOOD_BANK_INCOMING.RETRIEVE_TO_ORG && <GridButton type={"button"} theme={'yellow'} title={'عودت فرآورده'} icon={Resource.IMAGE.PACK.REPLY.BLACK} onClick={this.retrieve.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'ویرایش فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EDIT1.BLACK}" alt="">`,
                            action: this.update.bind(this, params.node.data),
                            disabled: !Perms().BLOOD_BANK_INCOMING.UPDATE
                        }, {
                            name: 'حذف فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TRASH1.BLACK}"/>`,
                            action: this.del.bind(this, params.node.data),
                            disabled: !Perms().BLOOD_BANK_INCOMING.DELETE
                        }, {
                            name: 'امحا فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TARGET.BLACK}"/>`,
                            action: this.destroy.bind(this, params.node.data),
                            disabled: !Perms().BLOOD_BANK_INCOMING.DESTROY
                        }, {
                            name: 'عودت فرآورده به سازمان',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.REPLY.BLACK}"/>`,
                            action: this.retrieve.bind(this, params.node.data),
                            disabled: !Perms().BLOOD_BANK_INCOMING.RETRIEVE_TO_ORG
                        },
                            'separator',
                            ...params.defaultItems];
                },
                onRowDoubleClicked: row => {
                    this.ref.modalProduct.current.open(row.data, ModalAction.VIEW);
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre'}>نشان دهنده گروه خونی فرآورده می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'green'}>موجود</GridState> فرآورده قابل استفاده می باشد.</p>
                                <p><GridState theme={"yellow"}>نزدیک به انقضا</GridState> فرآورده به تاریخ انقضا خود در سامانه نزدیک می شود.</p>
                                <p><GridState theme={'red'}>منقضی شده</GridState> تاریخ انقضا فرآورده در سامانه گذشته است.</p>
                                <p><GridState theme={'green'}>رزرو شده</GridState> فرآورده برای بیمار رزرو شده است.</p>
                                <p><GridState theme={'green'}>آماده ارسال</GridState> فرآورده جهت ارسال به بخش آماده شده است.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'edit'} title={'ویرایش'}/> درصورت نیاز به تغییر اطلاعات فرآورده می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'delete'} title={'حذف'}/> درصورت نیاز به حذف اطلاعات فرآورده می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'delete'} title={'امحا'} icon={Resource.IMAGE.PACK.TARGET.WHITE}/> در صورتی که قصد امحا فرآورده را دارید می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'edit'} title={'عودت'} icon={Resource.IMAGE.PACK.REPLY.BLACK}/> در صورتی که قصد عودت فرآورده به سازمان را دارید می توانید از این طریق اقدام کنید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            prompt: React.createRef(),
            modalProduct: React.createRef(),
            modalProductScan: React.createRef(),
            modalProductState: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData ||
            this.props.gridDefaultSettings !== nextState.gridDefaultSettings;
    }

    render() {
        return <React.Fragment>
            <BarcodeReader
                onScan={this.barcodeScanHandler.bind(this)}/>
            <Group className={'PageOrgIncoming-group mar-10'}>
                <GroupHead title={'فرآورده‌های ورودی'}>
                    {Perms().REPORTS.VIEW_READY_PRODUCTS && <Button className={'mar-s-4'} link={Resource.ROUTE.HOSPITAL.READY}>فرآورده‌های آماده</Button>}
                    {Perms().BLOOD_BANK_INCOMING.INSERT && <Button className={'mar-s-4'} theme={'green'} onClick={this.incomingBloodScanClickHandler.bind(this)}>اسکن فرآورده</Button>}
                    {Perms().BLOOD_BANK_INCOMING.INSERT && <Button className={'mar-s-4'} theme={'blue'} onClick={this.incomingBloodAddClickHandler.bind(this)}>ثبت فرآورده</Button>}
                </GroupHead>
                <GroupDescription>لیست فرآورده‌های اضافه شده از این قسمت قابل مشاهده می باشد.</GroupDescription>
                <Grid refer={this.ref.grid} id={'hemoIncoming'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <Prompt ref={this.ref.prompt}/>
            <ModalProduct refer={this.ref.modalProduct} onSuccess={this.updateGrid.bind(this)}/>
            <ModalProductScan refer={this.ref.modalProductScan} onSuccess={this.updateGrid.bind(this)}/>
            <ModalProductState refer={this.ref.modalProductState} onSuccess={this.updateGrid.bind(this)}/>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        Org.incomingList()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    barcodeScanHandler(code) {
        //barcodes
        const barcode = Tool.checkBarcode(code);
        if (barcode.type === 'PRODUCT_NUMBER') {
            this.state.gridContext.api.setFilterModel({
                productNumber: {
                    type: 'contains',
                    filter: barcode.data,
                }
            });
        }
    }

    del(row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید فرآورده مورد نظر را حذف کنید؟',
            buttons: PromptControl.YES_NO,
            onClose: button => {
                if (button.id === PromptControl.YES) {
                    props.loading();
                    Product.delete({
                        productId: row?.productId
                    }).then(_ => {
                        this.updateGrid();
                        new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();
                        props.loading(false);
                    }).catch(message => {
                        new Notif({message, theme: 'error'}).show();
                        props.loading(false);
                    });
                }
            }
        });
    };

    destroy(row) {
        this.ref.modalProductState.current.open(row, 'DESTROY');
    };

    incomingBloodAddClickHandler() {
        this.ref.modalProduct.current.open(null, ModalAction.INSERT);
    }

    incomingBloodScanClickHandler() {
        this.ref.modalProductScan.current.open(null, ModalAction.SCAN);
    }

    retrieve(row) {
        this.ref.modalProductState.current.open(row, 'RETRIEVE');
    };

    update(row) {
        this.ref.modalProduct.current.open(row, ModalAction.UPDATE);
    };
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(PageOrgIncoming);